export default __webpack_public_path__ + "static/B0102-27c033dfe34642671523874bf62914ea.png";